import React from 'react';
import { useTranslation } from 'react-i18next';
import Text from '@ingka/text';
import classes from './ContractHoursRow.module.scss';

const EmptyHeaders = ({ showTitles = false }: { showTitles?: boolean }) => {
    const { t } = useTranslation();

    return (
        <>
            <th>
                <Text className={showTitles ? classes.details : ''} textStyle="Body.M">{showTitles ? t('globals.labels.business_function') : ''}</Text>
            </th>
            <th>
                <Text className={showTitles ? classes.details : ''} textStyle="Body.M">{showTitles ? t('globals.labels.cost_centre') : ''}</Text>
            </th>
        </>
    );
};

export default EmptyHeaders;
